<template>
    <v-container grid-list-lg>
        <v-layout row wrap v-if="loadingCategories">
            <v-flex xs12 sm6 lg3 v-for="n in 3" :key="n">
                <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-flex>
        </v-layout>
        <v-layout row wrap class="category-products">
            <v-flex xs12 sm6 v-for="product in allProducts" :key="product.id">
                <v-card flat tile class="fill-height" max-height="294">
                    <v-row class="ma-0">
                        <v-col cols="12" lg="2" class="pa-0" v-if="$vuetify.breakpoint.lgAndUp">
                            <v-img
                                    :src="getProductImage(product.imageUrl)"
                                    contain
                                    max-width="173"
                                    class="d-inline-block"
                            >
                            </v-img>
                        </v-col>
                        <v-col cols="12" lg="10" class="pa-0 card-item">
                            <div class="grow">
                                <div class="product-title text-center text-sm-right">
                                    <h3>{{ product.name }}</h3>
                                </div>
                                <div class="product-info text-center text-sm-right">
                                    <div v-html="product.description"></div>
                                </div>
                            </div>
                            <div class="pb-2">
                                <div class="product-price text-center text-sm-right">
                                    <span class="price d-inline-flex primary--text" v-html="product.amountWithVat"></span>
                                    <span class="currency ml-1">Kč</span>
                                </div>
                                <div class="cart-icon text-center text-sm-right">
                                    <v-btn color="primary" outlined @click="addToCart({product: product, qty: 1})">Vložit do košíku</v-btn>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {getProductImage} from '../../Helper'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'Products',
        mixins: [getProductImage],
        computed: {
            ...mapGetters([
                'allProducts',
                'loadingCategories'
            ])
        },
        watch: {
            allProducts: function(newValue) {
                if (newValue) {
                    if (this.$gtm.enabled()) {
                        let products = [];

                        for (let i in this.allProducts) {
                            products.push({
                                id: this.allProducts[i].productId,
                                name: this.allProducts[i].name,
                                price: this.allProducts[i].amountWithVat,
                                category: this.allProducts[i].productCategoryName,
                                list: 'Home Page',
                                position: i + 1
                            })
                        }
                        this.$gtm.trackEvent({
                            event: 'productImpression', // Event type [default = 'interaction'] (Optional)
                            category: 'Ecommerce',
                            ecommerce: {
                                impressions: products
                            }
                        });
                    }
                }
            }
        },
        methods: {
            ...mapActions([
                'addToCart'
            ])
        }
    }
</script>

<style lang="scss">
    .category-products {
        .card-item {
            display: flex;
            flex-direction: column;
        }
        .clip-image {
            border: 1px solid #e9e9e9;
            .v-image__image {
                -webkit-clip-path: polygon(0% 0%, 30% 0%,20% 100%,0% 100%);
                clip-path: polygon(0% 0%, 30% 0%,20% 100%,0% 100%);
                @media #{$tablet-and-phone} {
                    background-image: none !important;
                }
            }
            .v-responsive__content {
                display: flex;
                flex-direction: column;
            }
        }
        .cart-button-wrapper {
            margin-top: -10px;
        }
        .cart-button {
            text-transform: initial;
        }
        .cursor-pointer {
            cursor: pointer;
        }
        .cart-icon {
            padding: 9px 20px;
            img {
                width: 60px;
                @media #{$tablet-and-phone} {
                    width: 30px;
                }
            }
        }
        .product-title {
            padding: 9px 20px;
            h3 {
                max-width: 70%;
                margin-left: auto;
                @media #{$tablet-and-phone} {
                    max-width: 100%;
                }
            }
        }
        .product-info {
            padding: 9px 20px;
            div {
                max-width: 70%;
                margin-left: auto;
                @media #{$tablet-and-phone} {
                    max-width: 100%;
                }
            }
            p {
                margin-bottom: 0;
            }
        }
        .product-price {
            padding: 9px 20px;
            @media #{$pixel-less-phone} {
                padding-top: 0;
            }
            .price {
                font-weight: 700;
                font-size: 42px;
                line-height: 38px;
                @media #{$pixel-less-phone} {
                    font-size: 25px;
                    line-height: 20px;
                }
            }
            .currency {
                font-size: 20px;
                @media #{$pixel-less-phone} {
                    font-size: 14px;
                }
            }
        }
        .product-title {
            text-transform: uppercase;
            color: #2f1917;
        }
    }
</style>
